















































































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { IStyle } from '~/assets/interfaces/classes'

@Component({
  components: {
    LazyHydrate,
  },
})
export default class ComponentLoadingDots extends Vue {
  @Prop({ default: false, type: Boolean }) readonly white!: boolean

  private $style!: IStyle

  private get classDots() {
    return {
      [this.$style.dots]: true,
      [this.$style.white]: this.white,
    }
  }
}
